import React, { useEffect, useState } from 'react';
import { animate } from 'framer-motion';
interface AnimatedNumberProps {
  value: number;
  delay?: number;
}
export function AnimatedNumber({
  value,
  delay = 0
}: AnimatedNumberProps) {
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    const controls = animate(0, value, {
      duration: 1.4,
      delay,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: v => setDisplay(Math.round(v))
    });
    return () => controls.stop();
  }, [value, delay]);
  return <span className="tabular-nums" data-id="element-1" data-mp="3d6ll6hl979o0">{display}</span>;
}